import siteConfig from '../promotion_config';

// Replace any inputs from the user and replace them with the appropriate replacement value.    Mostly used in the case
// on 'o's  VS zeros but can be used for any regular expression.
//
export const replaceBadTicketInput = (inputField) => {
    inputField.value = inputField.value.replace(siteConfig.badTicketInputReplacement, 0);
    return inputField;
};
